module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_8-1df9b7624c95fd1c5438850122e31802.jpg";